import type { DamageType, JobStatus, JobType, PhotoKind, Priority, Role, Shop, UsState, VehicleLocation } from "@agw/contracts";

// Display labels for every closed vocabulary. Keys are checked against the contract enums.

export { GLASS_LABEL } from "@agw/contracts";

export const DAMAGE_LABEL: Record<DamageType, string> = { chip: "Chip", crack: "Crack", shattered: "Shattered", other: "Other" };

export const JOB_TYPE_LABEL: Record<JobType, string> = {
  insurance: "Insurance",
  dealer_pay: "Dealer pay / recon",
  customer_pay: "Customer pay",
  warranty: "Warranty",
};

export const LOCATION_LABEL: Record<VehicleLocation, string> = {
  service_lane: "Service lane",
  used_car_lot: "Used-car lot",
  body_shop: "Body shop",
  customer_address: "Customer address",
};

export const PRIORITY_LABEL: Record<Priority, string> = { normal: "Normal", today: "Today", asap: "ASAP" };

export const PHOTO_KIND_LABEL: Record<PhotoKind, string> = {
  damage: "Damage",
  full_glass: "Entire windshield",
  vin_plate: "VIN pic",
  odometer: "Odometer",
  insurance_card: "Policy card",
  other: "Other",
};

export const STATUS_LABEL: Record<JobStatus, string> = {
  submitted: "Submitted",
  received: "Received",
  scheduled: "Scheduled",
  installed: "Installed",
  invoiced: "Invoiced",
  paid: "Paid",
  cancelled: "Cancelled",
  duplicate: "Duplicate",
};

export const ROLE_LABEL: Record<Role, string> = {
  sales_rep: "Sales rep",
  sales_manager: "Sales manager",
  dealership: "Dealership",
  agw_admin: "Admin",
};

export const SHOP_LABEL: Record<Shop, string> = {
  fort_myers: "Fort Myers",
  polk: "Polk",
  charleston: "Charleston",
  greer: "Greer",
};

export const options = <T extends string>(labels: Record<T, string>, only?: readonly T[]) =>
  (Object.keys(labels) as T[]).filter((k) => !only || only.includes(k)).map((value) => ({ value, label: labels[value] }));

const dateFmt = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" });
const dateTimeFmt = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export const fmtDate = (iso?: string) => (iso ? dateFmt.format(new Date(iso.length === 10 ? `${iso}T12:00:00` : iso)) : "");
export const fmtDateTime = (iso?: string) => (iso ? dateTimeFmt.format(new Date(iso)) : "");

export const STATE_LABEL: Record<UsState, string> = { FL: "Florida", SC: "South Carolina", NC: "North Carolina" };
